export type MenubarPathSegment = {
    section: string;
    page: string;
};

const MENUBAR_PATH_BY_ROUTE: Record<string, MenubarPathSegment> = {
    '/configure': { section: 'Edit', page: 'Roof' },
    '/configure/building': { section: 'Edit', page: 'Building' },
    '/configure/roof': { section: 'Edit', page: 'Roof' },
    '/configure/obstruction': { section: 'Edit', page: 'Obstruction' },
    '/configure/tree': { section: 'Edit', page: 'Tree' },
    '/configure/modules': { section: 'System Design', page: 'Modules' },
    '/configure/solar-access': { section: 'System Design', page: 'Shade Point' },
    '/configure/irradiance': { section: 'System Design', page: 'Irradiance' },
    '/configure/what-if': { section: 'Power+Pricing', page: 'What If' },
    '/configure/price-calculation': { section: 'Power+Pricing', page: 'EPC Calculation' },
    '/configure/surface-draw': { section: 'Ground Mount', page: 'Ground Mount' },
    '/configure/custom-image': { section: 'Map Imagery', page: 'Custom Imagery' },
    '/configure/packing-slip': { section: 'Packing Slip', page: 'Packing Slip' },
    '/configure/tape-measure': { section: 'Tools', page: 'Tape Measure' },
    '/configure/building/engineering-letter': { section: 'Edit', page: 'Engineering Letter' },
    '/configure/building/engineering-affidavit': { section: 'Edit', page: 'Engineering Affidavit' },
    '/configure/losses': { section: 'System Design', page: 'Losses' },
};

const PAGE_SECTION_FALLBACK: Record<string, string> = {
    building: 'Edit',
    roof: 'Edit',
    obstruction: 'Edit',
    tree: 'Edit',
    modules: 'System Design',
    'solar-access': 'System Design',
    irradiance: 'System Design',
    'what-if': 'Power+Pricing',
    'price-calculation': 'Power+Pricing',
    'surface-draw': 'Ground Mount',
    'custom-image': 'Map Imagery',
    'packing-slip': 'Packing Slip',
    'tape-measure': 'Tools',
};

const PAGE_LABEL_FALLBACK: Record<string, string> = {
    building: 'Building',
    roof: 'Roof',
    obstruction: 'Obstruction',
    tree: 'Tree',
    modules: 'Modules',
    'solar-access': 'Shade Point',
    irradiance: 'Irradiance',
    'what-if': 'What If',
    'price-calculation': 'EPC Calculation',
    'surface-draw': 'Ground Mount',
    'custom-image': 'Custom Imagery',
    'packing-slip': 'Packing Slip',
    'tape-measure': 'Tape Measure',
};

function normalizePathname(pathname: string): string {
    const trimmed = pathname.trim().replace(/\/+$/, '');
    return trimmed || '/configure/roof';
}

export function getMenubarPathFromPathname(pathname: string): MenubarPathSegment | null {
    const normalized = normalizePathname(pathname);

    if (!normalized.startsWith('/configure')) {
        return null;
    }

    if (MENUBAR_PATH_BY_ROUTE[normalized]) {
        return MENUBAR_PATH_BY_ROUTE[normalized];
    }

    const pageKey = normalized.replace(/^\/configure\/?/, '').split('/')[0];
    if (pageKey && PAGE_LABEL_FALLBACK[pageKey]) {
        return {
            section: PAGE_SECTION_FALLBACK[pageKey] ?? 'Configure',
            page: PAGE_LABEL_FALLBACK[pageKey],
        };
    }

    return { section: 'Configure', page: 'Editor' };
}
